import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio } from '@material-ui/core';
import { Field } from 'formik';
import { RadioGroup } from 'formik-material-ui';
import {
  HardwareHardeningStatus,
  hardwareHardeningStatusLabels,
} from '../../services/domainServices/HardwareService';

interface HardeningRadioGroupProps {
  className?: string;
  disabled: boolean;
}

// The caption is a fieldset legend rather than a <label>, so clicking it never
// activates one of the options and silently changes the saved status.
const HardeningRadioGroup = ({ className, disabled }: HardeningRadioGroupProps) => (
  <FormControl className={className} component="fieldset" disabled={disabled}>
    <FormLabel component="legend">hardening</FormLabel>
    <Field name="hardening" component={RadioGroup} id="input-hardening">
      {Object.keys(hardwareHardeningStatusLabels).map((status) => (
        <FormControlLabel
          key={status}
          value={status}
          control={<Radio color="primary" />}
          label={hardwareHardeningStatusLabels[status as HardwareHardeningStatus]}
          disabled={disabled}
        />
      ))}
    </Field>
  </FormControl>
);

export default HardeningRadioGroup;
